import { render, staticRenderFns } from "./FlexibleBenefitsFilters.vue?vue&type=template&id=2360d402&"
import script from "./FlexibleBenefitsFilters.vue?vue&type=script&lang=js&"
export * from "./FlexibleBenefitsFilters.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleBenefitsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports